import { useEffect, useState, useRef } from "react";
import "./Home.css";

import logo from "../../assets/images/logo.png";
import nom1 from "../../assets/images/nom1.png";
import nom2 from "../../assets/images/nom2.png";
import nom3 from "../../assets/images/nom3.png";



function App() {
  /*감지*/
 const introRef = useRef(null);
 const [startTyping, setStartTyping] = useState(false);
 
 useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setStartTyping(true);
        observer.disconnect();
      }
    },
    { threshold: 0.5 } 
  );

  if (introRef.current) {
    observer.observe(introRef.current);
  }

  return () => observer.disconnect();
}, []);
 
  /* 타이핑 효과용 */
  const typingText = "냉장고  제빙기  쇼케이스 수리";
  const [typed, setTyped] = useState("");
  const [index, setIndex] = useState(0);

  /* 타이핑 효과 */
 useEffect(() => {
  
  if (!startTyping) return;

  if (index < typingText.length) {
    const timer = setTimeout(() => {
      setTyped((prev) => prev + typingText[index]);
      setIndex(index + 1);
    }, 80);

    return () => clearTimeout(timer);
  }
}, [index, typingText, startTyping]);

  /* 슬라이드 등장 효과 */
  useEffect(() => {
    const items = document.querySelectorAll(".slide");
    items.forEach((item, i) => {
      setTimeout(() => {
        item.classList.add("active");
      }, i * 300);
    });
  }, []);

  return (

   

    <div className="App">
      {/*  로고 + 텍스트 */}
     <header className="header">
  <div className="brand-block">
    <img src={logo} alt="정진 더편한 생활 로고" className="logo" />
    <div className="brand-text-wrap">
      <h1 className="brand-text">정진 더편한 생활</h1>
      <p className="phrase">
        필요할 때 믿고 맡길 수 있는 업소용 냉장·냉동 수리
      </p>
    </div>
  </div>
</header>
    
        

      {/*  슬라이드 텍스트 + 이미지 */}
      <section className="slide">
        <img src={nom1} alt="사진1" />
        <div>
          <h2>대전 스타리온 업소용 냉장고 팬소음 수리</h2>
          <p>
           대전 중구 스타리온 업소 용 냉장고 소음으로 팬모터 교체 수리한 건입니다.
           흔히 45박스라고 일컫는 업소 용 냉장고의 경우 기계실이 상부에 위치하며 콤프레샤, 응축기 그리고 응축기 팬모터가 같이 있습니다.<br />
           이중 팬 모터의 경우 먼지나 기름 등의 이물로 소음이 나거나 회전 장애를 일으키는 경우가 있으며 이 경우 모터의 수명이 다했다고 판단하여 교체해 주시는 게 장차 발생할 냉장고 온도 상승을 막을 수 있습니다.

          </p>
        </div>
      </section>

      <section className="slide">
        <img src={nom2} alt="사진2" />
        <div>
          <h2>대전 유성구 카이저 제빙기 IMK-3121 수리</h2>
          <p>
            카이저 제빙기 IMK-3121 입니다. 물이 분사가 되지 않고 있습니다.<br />
            이 경우는 워터 펌프가 가동을 하지 않고 있는 것 입니다.교체 후 정상 동작합니다.<br />
            제빙기가 갑자기 시끄러워질 경우는 회전하는 부품의 문제가 생겼을 때입니다.<br />
            보통 두 가지 워터 펌프나 팬모터의 이상의 경우가 많습니다. <br />
            이럴 때는 잘 관찰하였다가 제빙이 되지 않으면 기계를 끄시고 수리를 하는 것이 좋습니다.
          </p>
        </div>
      </section>

      <section className="slide">
        <img src={nom3} alt="사진3" />
        <div>
          <h2>대전 세경 쇼케이스 수리</h2>
          <p>
            세경 쇼케이스를 사용 중 인데 소음이 너무 심하다고 합니다.<br />
            쇼케이스에서 소음이 지속되는 경우는 대부분 팬 모터와 관계가 있습니다.<br />
            이 경우는 모터를 교체를 해야 합니다. <br />
            응축기에 먼지도 많이 쌓여있어 제거 하였습니다.<br />
            응축기는 에어컨 실외기 라디에이터와 같은 역할이며 먼지가 많이 쌓이면 냉매 냉각을 시키지 못해 냉각 효율이 떨어져서 기계의 가동 시간이 늘어나서 전기료 상승, 기계장치 수명 단축, 주변 온도 상승 등 많은 부작용 이 발생합니다.<br />
            따라서 응축기 먼지는 수시로 제거해 주는게 필수 입니다

          </p>
        </div>
      </section>

      {/*  타이핑 + 페이드 텍스트 */}
      <section className="intro" ref={introRef}>
        <h2 className="typing"> {typed.includes("수리")
    ? (<>{typed.replace(" 수리", "")}<span className="highlight"> 수리</span></>)
    : typed}</h2>
        <p className={`fade ${startTyping ? "active" : ""}`}>
        정진냉동은 대전·옥천·공주·계룡·금산·세종 지역을 중심으로 <br />
        업소용 냉장고 수리, 에어컨 냉매 보충, 제빙기 및 쇼케이스 수리 등<br />
        각종 냉장·냉동 설비의 전문 유지보수를 제공하는 업체입니다.<br />
        신속하고 정확한 점검으로 고객님의 불편을 빠르게 해결해 드립니다.
        </p>
      </section>
    </div>
  );
}

export default App;